export default __webpack_public_path__ + "src/assets/facebook.8276c70df32716b3dd61397f810768b5.svg";